var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9 14.199C22.9 13.5785 22.8443 12.9819 22.7409 12.4092H14.5V15.7938H19.2091C19.0063 16.8876 18.3898 17.8143 17.4631 18.4348V20.6302H20.2909C21.9455 19.1069 22.9 16.8637 22.9 14.199Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 22.7501C16.8625 22.7501 18.8432 21.9666 20.2909 20.6302L17.4631 18.4348C16.6795 18.9598 15.6773 19.27 14.5 19.27C12.221 19.27 10.292 17.7308 9.60396 15.6626H6.68066V17.9296C8.12044 20.7893 11.0795 22.7501 14.5 22.7501Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60398 15.6624C9.42898 15.1374 9.32955 14.5766 9.32955 13.9999C9.32955 13.4232 9.42898 12.8624 9.60398 12.3374V10.0703H6.68068C6.08807 11.2516 5.75 12.5879 5.75 13.9999C5.75 15.4118 6.08807 16.7482 6.68068 17.9294L9.60398 15.6624Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8.73012C15.7847 8.73012 16.9381 9.1716 17.8449 10.0386L20.3546 7.52898C18.8392 6.11705 16.8585 5.25 14.5 5.25C11.0795 5.25 8.12044 7.2108 6.68066 10.0705L9.60396 12.3375C10.292 10.2693 12.221 8.73012 14.5 8.73012Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5c4b844ec03480738baa19fc562160f7.svg";
export { ForwardRef as ReactComponent };